import { createClient } from '@sanity/client';

export const client = createClient({
  projectId: 'bh4x7js3', // Your project ID from sanity.cli.js
  dataset: 'production', // Your dataset from sanity.cli.js
  apiVersion: '2023-01-01', // You can update this to the latest date or a specific date you prefer
  useCdn: true, // `false` if you want to ensure fresh data
});

export default client;
